import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

type Props = {
  bearing: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetNorth: () => void;
};

export default function NavigationControl({
  bearing,
  onZoomIn,
  onZoomOut,
  onResetNorth,
}: Props): JSX.Element {
  return (
    <div className="mapboxgl-ctrl mapboxgl-ctrl-group">
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in"
        title={t('Zoom in')}
        {...onClickGenerator(onZoomIn)}
      >
        <span className="mapboxgl-ctrl-zoom-in-icon" aria-hidden="true" />
      </button>
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out"
        title={t('Zoom out')}
        {...onClickGenerator(onZoomOut)}
      >
        <span className="mapboxgl-ctrl-zoom-out-icon" aria-hidden="true" />
      </button>
      <button
        className="mapboxgl-ctrl-icon mapboxgl-ctrl-compass"
        title={t('Reset bearing to north')}
        {...onClickGenerator(onResetNorth)}
      >
        <span
          className="mapboxgl-ctrl-compass-arrow"
          style={{ transform: `rotate(${bearing}deg)` }}
        />
      </button>
    </div>
  );
}
